<template>
<v-app-bar v-show="$route.name == 'Home' || $vuetify.breakpoint.width > 600" elevation="2" height="60">

    <div class="d-flex flex-row align-center">
        <v-tooltip v-if="$vuetify.breakpoint.width > 600" bottom color="secondary">

            <template v-slot:activator="{ on, attrs }">
                <!-- <v-btn icon v-bind="attrs" v-on="on" :to="{name: 'Home'}">
            <v-icon :color="getBottomNavigationSelectedItem == 4 ? 'primary' : 'secondary'">mdi-home</v-icon>
          </v-btn> -->
                <router-link :to="{name: 'Home'}">
                    <v-img style="cursor: pointer" contain v-bind="attrs" v-on="on" src="@/assets/paloot-logo.png" max-width="60px" max-height="30px">
                    </v-img>
                </router-link>
            </template>
            <span class="regular-font">خانه</span>
        </v-tooltip>

        <v-tooltip v-if="$vuetify.breakpoint.width > 600" bottom color="secondary">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" :to="{name: 'ConfirmBasket'}">
                    <v-badge :content="getCartItemsCount" :value="getCartItemsCount" color="primary" overlap>
                        <v-icon :color="
                  getBottomNavigationSelectedItem == 3 ? 'primary' : 'secondary'
                ">mdi-cart</v-icon>
                    </v-badge>
                </v-btn>
            </template>
            <span class="regular-font">سبد خرید</span>
        </v-tooltip>

        <v-tooltip v-if="$vuetify.breakpoint.width > 600" bottom color="secondary">
            <template v-if="$vuetify.breakpoint.width > 600" v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" :to="{name: 'ProfileFavourites'}">
                    <v-icon :color="
                getBottomNavigationSelectedItem == 2 ? 'primary' : 'secondary'
              ">mdi-heart</v-icon>
                </v-btn>
            </template>
            <span class="regular-font">علاقه‌مندی</span>
        </v-tooltip>
    </div>

    <div v-if="
        !($route.query.cart || $route.query.favorite || $route.query.profile)
      " class="header-section">
        <v-menu>
            <template v-slot:activator="{ on, attrs }">
                <v-text-field dense v-model="search" v-on:keyup.enter="showMoreSearchedProducts" @click:append="showMoreSearchedProducts" :append-icon="getAppendIcon()" @click:clear="clearSearch" class="regular-font mt-7 rounded" label="جستجو" placeholder="نام محصول یا برند مورد نظر را به ترکی وارد کنید" background-color="white" outlined clearable full-width :style="`
              max-width:${$vuetify.breakpoint.width <= 600 ? 'calc(100% - 40px)' : '400px'};
              width:${$vuetify.breakpoint.width <= 600 ? 'calc(100% - 40px)' : 'auto'}
              `" :disabled="priceLoading || creditLoading" v-bind="attrs" v-on="on">
                </v-text-field>
            </template>
        </v-menu>
    </div>

    <v-spacer></v-spacer>

    <div v-if="$vuetify.breakpoint.width > 600"></div>

    <div class="d-flex flex-row">
        <div v-if="isLoggedIn && $vuetify.breakpoint.width > 600 && getCredit > 0" class="d-flex flex-row" style="gap: 0.5rem">
            <v-btn :loading="creditLoading" class="my-auto" icon outlined small>
                <v-icon>mdi-wallet</v-icon>
            </v-btn>
            <p v-if="!creditLoading && $vuetify.breakpoint.mdAndUp" class="my-auto text-caption text-sm-body-2 text-md-body-1">
                <span class="regular-font">کیف پول: </span>
            </p>
            <p v-if="!creditLoading" class="my-auto text-caption text-sm-body-2 text-md-body-1">
                <span class="regular-font">{{ getCredit + " لیر " }}</span>
            </p>
        </div>

        <div v-if="$vuetify.breakpoint.width > 600" class="d-flex flex-row mx-3" style="gap: 0.5rem">
            <v-btn :loading="priceLoading" class="my-auto" icon outlined small @click="fetchMultiplier">
                <v-icon>mdi-currency-try</v-icon>
            </v-btn>
            <p v-if="!priceLoading && $vuetify.breakpoint.mdAndUp" class="my-auto text-caption text-sm-body-2 text-md-body-1">
                <span class="regular-font">نرخ لیر: </span>
            </p>
            <p v-if="!priceLoading" class="my-auto regular-font">
                <span class="regular-font">{{ getMultiplier + " تومان " }}</span>
            </p>
        </div>

<!--        <v-btn icon class="d-sm-block d-none" v-if="getLang == 'tr'" @click="setLang('fa')">-->
<!--            <v-icon>$turkiye</v-icon>-->
<!--        </v-btn>-->
<!--        <v-btn icon class="d-sm-block d-none" v-if="getLang == 'fa'" @click="setLang('tr')">-->
<!--            <v-icon>$iran</v-icon>-->
<!--        </v-btn>-->

        <v-menu v-if="$vuetify.breakpoint.width > 600" offset-y transition="slide-y-transition">
            <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                    <v-icon>mdi-account</v-icon>
                </v-btn>
            </template>
            <v-card color="white" class="mt-1" rounded="lg">
                <v-list v-if="isLoggedIn" color="white">
                    <v-list-item class="d-flex flex-row">
                        <v-list-item-title class="regular-font">{{
                getProfile?.name
              }}</v-list-item-title>
                        <v-btn icon @click="logoutDialog = true">
                            <v-icon color="primary">mdi-logout</v-icon>
                        </v-btn>
                    </v-list-item>

                    <!-- <v-list-item :to="{name: 'ProfileFavourites'}"  link>
              <v-list-item-title class="regular-font" >
                آدرس‌های من
              </v-list-item-title>
            </v-list-item> -->

                    <v-list-item v-for="(item, index) in items" :key="index" :prepend-icon="item.icon" :to="{name: item.route}" link>
                        <!-- <v-list-item-icon>
                <v-icon :value="item.icon"></v-icon>
              </v-list-item-icon> -->
                        <v-list-item-title class="regular-font" :to="{name: item.route}">{{
                item.title
              }}</v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-list v-else>
                    <RouterLink :to="{name: 'Login'}">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon>mdi-login</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="regular-font">ورود به حساب کاربری</v-list-item-title>
                        </v-list-item>
                    </RouterLink>

                    <RouterLink :to="{name: 'Register'}">
                        <v-list-item>
                            <v-list-item-icon>
                                <v-icon>mdi-how-to-reg</v-icon>
                            </v-list-item-icon>
                            <v-list-item-title class="regular-font">ساخت حساب کاربری</v-list-item-title>
                        </v-list-item>
                    </RouterLink>
                </v-list>
            </v-card>
        </v-menu>
    </div>

    <v-snackbar v-model="snackbar" :timeout="3000" color="success">
        <span class="bold-font">{{
        "با موفقیت از حساب کاربری خود خارج شدید"
      }}</span>
    </v-snackbar>

    <logout-dialog v-model="logoutDialog" @click:submit="logout" />
</v-app-bar>
</template>

<script>
import { RouterLink } from "vue-router";
import LogoutDialog from "./base/LogoutDialog.vue";
import {
    mapActions,
    mapGetters
} from "vuex";

export default {
    name: "AppBar",
    components: {
    LogoutDialog,
    RouterLink
},
    data() {
        return {
            logoutDialog: false,
            snackbar: false,
            search: "",
            debounce: null,
            items: [{
                    index: 2,
                    title: "آدرس های من",
                    icon: "mdi-home",
                    route: 'ProfileAddresses'
                },
                {
                    index: 3,
                    title: "سفارشات",
                    icon: "mdi-shopping",
                    route: 'ProfileOrders'
                },
                {
                    index: 4,
                    title: "قوانین و مقررات",
                    icon: "mdi-checkbox-blank-circle",
                    route: 'ProfileRules'
                },
                {
                    index: 5,
                    title: "ارتباط با ما",
                    icon: "mdi-checkbox-blank-circle",
                    route: 'ProfileContactUs'
                },
            ],
        };
    },
    methods: {
        ...mapActions("product", ["setProduct"]),
        ...mapActions("home", [
            "setSearchInput",
            "setSearchInputBox",
            "showSearchedProducts",
            "showSearchedBrands",
            "clearSearchedProducts",
            "fetchProductsByBrandId",
            "setSearching",
            "setSearchQuery",
            "setFilterType",
            "setLang"
        ]),

        ...mapActions("auth", ["logout"]),
        ...mapActions("credit", ["fetchCredit"]),
        ...mapActions("price", ["fetchMultiplier"]),
        getAppendIcon() {
            return this.isSearching ? this.showSpinnerIcon() : "mdi-magnify";
        },
        showSpinnerIcon() {
            // Add your logic here to return the appropriate icon when isSearching is true
            // For example, you can return the icon for the spinner
            return "mdi-loading mdi-spin";
        },
        showMoreSearchedProducts() {
            if (this.search.length > 2) {
                this.setSearching(true);
                const searchItem = {
                    name: this.search,
                    from: 0,
                    count: 5,
                };
                this.setSearchInputBox(searchItem);
                console.log("redirecting ....");
                this.setFilterType("keyword");
                this.setSearchQuery(this.search);
                this.$router.push({
                    name: 'Search',
                    params: {
                        term: this.search,
                    },
                });
            }
            return
        },

        onProductSelect(product) {
            this.setProduct(product);
            this.$router.push({
                name: "Product",
                params: {
                    product: product,
                },
                query: {
                    id: product.id,
                },
            });
        },

        onBrandSelect(brand) {
            this.$router.replace({
                name: "Home",
                query: {
                    brand: brand.id,
                },
            });
            this.fetchProductsByBrandId(brand.id);
        },
        handleEnter() {
            this.setFilterType();
            this.$router.push({
                path: "/products",
                query: {
                    search: this.search
                }
            });
        },
        clearSearch() {
            this.search = "";
            this.setSearching(false);
            this.debounce = null;
        }
    },
    computed: {
        ...mapGetters("home", [
            "getSearchInput",
            "isSearching",
            "getSearchedProducts",
            "getSearchedProductsSliced",
            "getAllBrands",
            "getLang"
        ]),
        ...mapGetters("auth", ["isLoggedIn", "getProfile"]),
        ...mapGetters(["getBottomNavigationSelectedItem"]),
        ...mapGetters("cart", ["getCartItemsCount"]),
        ...mapGetters("credit", ["hasCredit", "getCredit", "creditLoading"]),
        ...mapGetters("price", ["getMultiplier", "priceLoading"]),

        getSearchedBrands() {
            const brands = this.getAllBrands.filter((brand) => {
                return brand.name
                    .trim()
                    .toLowerCase()
                    .includes(this.search.trim().toLowerCase());
            });

            return brands.slice(0, 3);
        },
        getAllSearchedBrands() {
            return this.getAllBrands.filter((brand) => {
                return brand.name.includes(this.search);
            });
        },
    },
    beforeMount() {
        this.fetchMultiplier();
        this.fetchCredit();
    },
    watch: {
        search([, ]) {

        },
    },
};
</script>

<style scoped>
a{
    text-decoration: none;
}
.header-section {
    width: 400px;
    position: relative;
}

.v-menu__content {
    top: 55px !important;
    max-width: 400px;
}

.rounded {
    border-radius: 20px !important;
}

@media only screen and (max-width: 600px) {
    .v-menu__content {
        max-width: 600px;
    }
}

::v-deep .header-section>.v-input>.v-input__control>.v-input__append-inner>.v-input__icon>.mdi-magnify {
    cursor: pointer !important;
    border-radius: 50% !important;
    padding: 2px !important;
}
</style>
